import { render, staticRenderFns } from "./SocialLogin.vue?vue&type=template&id=0fee241b&scoped=true&"
import script from "./SocialLogin.vue?vue&type=script&lang=ts&"
export * from "./SocialLogin.vue?vue&type=script&lang=ts&"
import style0 from "./SocialLogin.vue?vue&type=style&index=0&id=0fee241b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fee241b",
  null
  
)

export default component.exports